import {
    EDIT_FAVICON_SUCCESS,
} from '../actionTypes'

import favicons from '../data/favicons'

const InitialState = ''

export default (state = InitialState, {type, payload}) => {
    switch (type) {
        case EDIT_FAVICON_SUCCESS:
            return payload

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/favicon.js